import { useState, useEffect } from 'react';
import { View } from 'foundations-components/components/View';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';

/**
 * Renders an invisible SegmentationFilters component in edit mode in order to
 * preload its caches. Improves the loading performance for both
 * ListSegmentationFilters and EventSegmentationFilters.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function PreloadSegmentationFilters({
  objectTypeId,
  delay = NaN
}) {
  const isTestCase = !!window.jasmine;
  const shouldRenderImmediately = Number.isNaN(delay) && !isTestCase;
  const [shouldRender, setShouldRender] = useState(shouldRenderImmediately);
  useEffect(() => {
    if (shouldRender || isTestCase) {
      return;
    }
    const timeout = setTimeout(() => {
      setShouldRender(true);
    }, delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(View, {
    display: "none",
    children: shouldRender && /*#__PURE__*/_jsx(ListSegmentationFilters, {
      objectTypeId: objectTypeId,
      readOnly: false,
      openInEditMode: true
    })
  });
}